export const aboutRoutes = {
  root: '/about',
};
